import { render, staticRenderFns } from "./OrderPaymentNew.vue?vue&type=template&id=5c160f41&lang=pug&"
import script from "./OrderPaymentNew.vue?vue&type=script&lang=ts&"
export * from "./OrderPaymentNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports